module.exports = __webpack_public_path__ + "img/check.cdbf310b.svg";